import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { COUNTRY_CODE } from "config/global";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const containsArticle = location.pathname.includes("article");

  const headerLogo =
    COUNTRY_CODE === "id" ? require("assets/header-logo.png") : require("assets/header-logo-other.png");
  const headerLogoClassName = COUNTRY_CODE === "id" ? "w-[174px] lg:w-[283px]" : "w-[178px] lg:w-[288px]";

  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (containsArticle) {
    return (
      <header
        className={`sticky z-10 top-0 w-screen transition-all duration-200 ${scrolled ? "bg-white" : "bg-transparent"}`}
      >
        <div className="h-14 lg:h-[90px] flex items-center px-4 py-3 lg:px-0 lg:py-4 container">
          <img
            onClick={() => navigate(-1)}
            className="rotate-180 w-8 cursor-pointer"
            src={require("assets/icons/arrow-right.svg").default}
            alt="logo"
          />
          <div className="flex items-center justify-center w-[calc(100%-64px)]">
            <img className={headerLogoClassName} src={headerLogo} alt="logo" />
          </div>
        </div>
      </header>
    );
  }

  return (
    <header
      className={`fixed z-10 top-0 w-screen transition-all duration-200 ${
        scrolled ? "bg-primary-dark" : "bg-transparent"
      }`}
    >
      <div className="h-14 lg:h-[90px] flex items-center">
        <div className="px-4 py-3 lg:px-0 lg:py-4 container flex items-center">
          <img className={headerLogoClassName} src={headerLogo} alt="logo" />
        </div>
      </div>
    </header>
  );
};

export default Header;
